import { render, staticRenderFns } from "./Mengdian.vue?vue&type=template&id=afb15210&"
import script from "./Mengdian.vue?vue&type=script&lang=js&"
export * from "./Mengdian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports